import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

export const DynamicMetaTags = ({ metaString }) => {
    const [headElements, setHeadElements] = useState([]);

    useEffect(() => {
        const parseHeadElements = (htmlString) => {
            const parser = new DOMParser();
            const parsed = parser.parseFromString(htmlString, "text/html");
            const elements = Array.from(parsed.head.children);

            return elements.map((el) => {
                const tagName = el.tagName.toLowerCase();

                // Collect attributes
                const attributes = Array.from(el.attributes).reduce((acc, attr) => {
                    const safeName = attr.name.replace(/[^\w-]/g, ''); // sanitize
                    acc[safeName] = attr.value;
                    return acc;
                }, {});

                const elementData = {
                    type: tagName,
                    attributes,
                    content: el.textContent,
                };

                return elementData;
            });
        };

        setHeadElements(parseHeadElements(metaString));
    }, [metaString]);

    return (
        <Helmet>
            {headElements.map((el, index) => {
                const commonProps = {
                    key: index,
                    ...el.attributes
                };

                switch (el.type) {
                    case "title":
                        return <title key={index}>{el.content}</title>;
                    case "meta":
                        return <meta {...commonProps} key={index} />;
                    case "link":
                        return <link {...commonProps} />;
                    case "script":
                        return <script {...commonProps} dangerouslySetInnerHTML={{ __html: el.content }} key={index} />;
                    case "style":
                        return <style {...commonProps} dangerouslySetInnerHTML={{ __html: el.content }} key={index} />;
                    case "base":
                        return <base {...commonProps} key={index} />;
                    case "noscript":
                        return <noscript {...commonProps} dangerouslySetInnerHTML={{ __html: el.content }} key={index} />;
                    default:
                        return null;
                }
            })}
        </Helmet>
    );
};

